function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#247dbd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M16.313,16.523H22.3V33.6H16.313Z",
  transform: "translate(-16.313 -4.682)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M16.313,9.844H22.3v5.983H16.313Z",
  transform: "translate(-16.313 -9.844)"
});

const SvgIconTipo = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5.983,
    height: 28.919,
    viewBox: "0 0 5.983 28.919",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTipo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Tipo.c1686d9a.svg";
export { ForwardRef as ReactComponent };